<script setup lang="ts">
  import {
    FormFieldContainer,
    LoadingSpinner,
    UiButton,
    useWebSocketClient,
    require,
    type TransactionResponse,
  } from '@logistiek-zonder-papier/lzp-library'
  import { ref } from 'vue'

  const { ready, subscribe, unsubscribe } = useWebSocketClient(
    require(localStorage.getItem('jwt_token')),
    'wsbd-roosendaal'
  )

  type Status = 'idle' | 'waiting' | 'complete'
  const status = ref<Status>('idle')

  function update(response: Partial<TransactionResponse>) {
    if (response.action === 'message') {
      status.value = 'complete'
      unsubscribe()
    }
  }

  function testConnection() {
    status.value = 'waiting'
    subscribe(update)
  }

  function showStatus(): string {
    if (status.value === 'idle') return 'Test Connection'
    if (status.value === 'waiting') return 'Connecting'
    if (status.value === 'complete') return 'Connected'
    throw Error('invalid status')
  }
</script>

<template>
  <FormFieldContainer label="Connection" class="container">
    <div class="connector">
      <UiButton
        :label="showStatus()"
        :disabled="!ready"
        variant="prominent"
        :class="{ 'connect-button': status === 'complete' }"
        @click.prevent="status !== 'complete' ? testConnection() : {}"
      />
      <LoadingSpinner v-if="status === 'waiting'" size="sm" />
    </div>
  </FormFieldContainer>
</template>

<style scoped lang="css">
  .container {
    width: 100%;
    padding: 0.5rem;
  }

  .connector {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .connect-button {
    background-color: var(--colours-support-positive);
  }
</style>
